// Text Info Box
export const LAPTOP_HEIGHT = 650;
export const LAPTOP_WIDTH = 600;

// Tattoo Size
export const ORIGINAL_WIDTH = 1753;
export const ORIGINAL_HEIGHT = 2480;

// Heights
export const MOBILE_SIZER_HEIGHT = 60;
export const HEADER_HEIGHT = 100;
export const MIN_VIEWER_HEIGHT = 300;

export type SpotType = {
	link: string;
	title: string;
	x: number;
	y: number;
};
